@if (!hidden) {
<a [routerLink]="link" [queryParams]="queryParams" class="tcl-link">
    @if (showPlus) {
    <span class="tcl-plus" aria-hidden="true">+</span>
    }
    {{ label }}
</a>
}
